/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductObjectListPage = lazyLoad(
  () => import('./index'),
  module => module.ProductObjectListPage
);
